import { useEffect, useState } from "react";
import { useLang, LOCALES } from "@/lib/i18n";

const TZ = "Asia/Gaza";
const dateFmtAr = new Intl.DateTimeFormat("ar-EG-u-nu-latn", { timeZone: TZ, weekday: "long", year: "numeric", month: "long", day: "numeric" });
const dateFmts = { ar: dateFmtAr };
const dateFmtFor = (lang) => (dateFmts[lang] ||= new Intl.DateTimeFormat(LOCALES[lang] || "en-GB", { timeZone: TZ, weekday: "long", year: "numeric", month: "long", day: "numeric" }));
const timeFmt = new Intl.DateTimeFormat("en-US", { timeZone: TZ, hour: "numeric", minute: "2-digit", hour12: true });

function snapshot(lang = "ar") {
    const dateFmt = dateFmtFor(lang);
    const now = new Date();
    const parts = timeFmt.formatToParts(now);
    const get = (t) => parts.find((p) => p.type === t)?.value || "";
    const pm = get("dayPeriod").toUpperCase().startsWith("P");
    const period = lang !== "ar" ? (pm ? "PM" : "AM") : (pm ? "م" : "ص");
    const d = dateFmt.format(now);
    return { date: lang === "ar" ? d : d.charAt(0).toUpperCase() + d.slice(1), time: `${get("hour")}:${get("minute")}`, period };
}

export default function GazaDateTime() {
    const { lang, dir, t } = useLang();
    const [now, setNow] = useState(() => snapshot(lang));

    useEffect(() => {
        let timer;
        const tick = () => {
            setNow(snapshot(lang));
            const ms = 60000 - (Date.now() % 60000) + 50;
            timer = setTimeout(tick, ms);
        };
        tick();
        const onVisible = () => { if (document.visibilityState === "visible") { clearTimeout(timer); tick(); } };
        document.addEventListener("visibilitychange", onVisible);
        window.addEventListener("focus", onVisible);
        return () => {
            clearTimeout(timer);
            document.removeEventListener("visibilitychange", onVisible);
            window.removeEventListener("focus", onVisible);
        };
    }, [lang]);

    return (
        <span className="beam-ring beam-ring--slow rounded-md topbar-ctl topbar-datetime-ring" data-testid="topbar-datetime-beam">
            <span className="topbar-datetime" dir={dir} data-testid="topbar-datetime">
                <span data-testid="today-date" className="topbar-date">{now.date}</span>
                <span className="topbar-sep" aria-hidden="true">·</span>
                <time data-testid="gaza-clock" className="gaza-clock" dateTime={now.time} aria-label={`${t("gazaTimeLabel")} ${now.time} ${now.period}`}>
                    <span className="gaza-clock-digits">{now.time}</span>
                    <span className="gaza-clock-period">{now.period}</span>
                </time>
            </span>
        </span>
    );
}
